import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["tableButton", "kanbanButton", "tableView", "kanbanView"];
  static values = { currentView: String };

  connect() {
    // Default to table view
    this.currentViewValue = this.currentViewValue || "table";
    this.showView(this.currentViewValue);
  }

  showTable() {
    this.showView("table");
  }

  showKanban() {
    this.showView("kanban");
  }

  showView(viewType) {
    this.currentViewValue = viewType;

    // Update button states
    this.updateButtonStates(viewType);

    // Show/hide views
    if (viewType === "table") {
      if (this.hasTableViewTarget) {
        this.tableViewTarget.classList.remove("hidden");
      }
      if (this.hasKanbanViewTarget) {
        this.kanbanViewTarget.classList.add("hidden");
      }
    } else if (viewType === "kanban") {
      if (this.hasTableViewTarget) {
        this.tableViewTarget.classList.add("hidden");
      }
      if (this.hasKanbanViewTarget) {
        this.kanbanViewTarget.classList.remove("hidden");
      }
    }
  }

  updateButtonStates(activeView) {
    const buttons = [
      { target: this.tableButtonTarget, view: "table" },
      { target: this.kanbanButtonTarget, view: "kanban" },
    ];

    buttons.forEach(({ target, view }) => {
      if (target) {
        if (view === activeView) {
          target.classList.add(
            "text-stone-700",
            "bg-white",
            "shadow-sm",
            "border-stone-400"
          );
          target.classList.remove(
            "text-stone-500",
            "hover:text-stone-800",
            "hover:underline",
            "border-transparent"
          );
        } else {
          target.classList.remove(
            "text-stone-700",
            "bg-white",
            "shadow-sm",
            "border-stone-400"
          );
          target.classList.add(
            "text-stone-500",
            "hover:text-stone-800",
            "hover:underline",
            "border-transparent"
          );
        }
      }
    });
  }
}
